// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/lateral-stability.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/lateral-stability/lateral-stability-in-turns.js';
import g1 from '../lessons/aeronautics/lateral-stability/lateral-stability.js';

mount([g0, g1]);
